module.exports = __webpack_public_path__ + "img/selected2-min.f364d3d6.png";